import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
// import { Footer } from '@adc/ui-adc'
import Footer from '@adc/ui-adc/components/footer';
import { getWebComponentName, getTheme, getEmbeddedContext } from '../utils';
import classnames from 'classnames/bind';
// @ts-ignore next
import styles from '../base.scss';
const cx = classnames.bind(styles);
const WrappedComponent = props => (React.createElement(Footer, { ...props, className: cx('component-root'), theme: getTheme(), embeddedContext: getEmbeddedContext() }));
const WebComponent = r2wc(WrappedComponent);
customElements.define(getWebComponentName('footer'), WebComponent);
